import * as THREE from 'three';
import { ParticleSystem, SHARED_VERTEX_SHADER, SHARED_FRAGMENT_SHADER } from '../core/ParticleSystem.js';

/**
 * Hero Scene - Vast embedding space visualization
 * A field of particles representing points in AI's understanding space
 */
export class HeroScene extends ParticleSystem {
  constructor(count = 5000) {
    super(count);
    this.initHeroPositions();
  }

  initHeroPositions() {
    const positions = this.geometry.attributes.position.array;
    const colors = this.geometry.attributes.color.array;
    const sizes = this.geometry.attributes.size.array;

    for (let i = 0; i < this.count; i++) {
      const i3 = i * 3;

      // Create a vast spherical distribution with some clustering
      const radius = Math.pow(Math.random(), 0.5) * 80;
      const theta = Math.random() * Math.PI * 2;
      const phi = Math.acos(2 * Math.random() - 1);

      positions[i3] = radius * Math.sin(phi) * Math.cos(theta);
      positions[i3 + 1] = radius * Math.sin(phi) * Math.sin(theta);
      positions[i3 + 2] = radius * Math.cos(phi);

      // Color variation
      const cluster = Math.random();
      if (cluster > 0.92) {
        // Cyan accent particles (matching --accent-cyan: #5ecfcf)
        colors[i3] = 0.37;
        colors[i3 + 1] = 0.81;
        colors[i3 + 2] = 0.81;
      } else if (cluster > 0.85) {
        // Gold accent particles (matching --accent-gold: #d4a84b)
        colors[i3] = 0.83;
        colors[i3 + 1] = 0.66;
        colors[i3 + 2] = 0.29;
      } else {
        // Warm off-white (matching --text-primary: #f5f0e6)
        colors[i3] = 0.96 + Math.random() * 0.04;
        colors[i3 + 1] = 0.94 + Math.random() * 0.04;
        colors[i3 + 2] = 0.90 + Math.random() * 0.05;
      }

      // Wide size variation
      const randomVariation = 0.3 + Math.random() * 3.0;
      sizes[i] = (0.5 + Math.random() * 10.0) * randomVariation;
    }

    this.geometry.attributes.position.needsUpdate = true;
    this.geometry.attributes.color.needsUpdate = true;
    this.geometry.attributes.size.needsUpdate = true;
  }

  // Use shared shaders for consistent look across all scenes
  getVertexShader() {
    return SHARED_VERTEX_SHADER;
  }

  getFragmentShader() {
    return SHARED_FRAGMENT_SHADER;
  }
}
